import { useCallback } from 'react';
import usePluginHandler from '../../../hooks/usePluginHandler';
import { isCalledByParent } from '../../../models/caller';
import { PluginMessageTypes } from '../../../models/constants';
import { setLocation, setLocationHash } from '../../../utils/navigation';

/**
 * Gestione goto demandati al parent
 */
export default function useGotoExternal(onRedirectUrl) {
  /**
   * Evento inviato dal child per effettuare nel parent un redirect ad un url specifico
   */
  const eventoGotoExternalUrl = useCallback((url) => {
    if (onRedirectUrl) {
      onRedirectUrl(url);
    } else {
      setLocation(url);
    }
  }, [onRedirectUrl]);

  const messageHandler = useCallback((message) => {
    if (message.type === PluginMessageTypes.GOTO_EXTERNAL_HASH) {
    // richiesta navigazione esterna all'iframe (hash)
      // se sono dentro un'altro parent allora lo faccio fare a lui
      if (!isCalledByParent()) {
        setLocationHash(message.payload);
      }
    } else if (message.type === PluginMessageTypes.GOTO_EXTERNAL_URL) {
      // richiesta navigazione esterna all'iframe (url)
      // se sono dentro un'altro parent allora lo faccio fare a lui
      if (!isCalledByParent()) {
        eventoGotoExternalUrl(message.payload);
      }
    }
  }, [eventoGotoExternalUrl]);

  usePluginHandler(messageHandler);
}
